import React from "react";
import Drops from "./Drops";
import "./GameScreen.css";
import Tutorial from "./Tutorial";

interface IGameScreenProps {
  level: number;
  restartLevel: () => void;
  mp: number;
  step: number;
  closeModal: () => void;
  drops: Record<string, number>;
}
export default function GameScreen(props: IGameScreenProps) {
  const { level, mp, drops, step, restartLevel, closeModal } = props;
  return (
    <>
      <Tutorial step={step} close={closeModal} />
      <div className="game-screen">
        <div className="level-label">
          <span>Level</span>
          <span>{`${level + 1}`}</span>
        </div>
        {mp <= 0 && (
          <button type="button" onClick={restartLevel}>
            Restart
          </button>
        )}
        <Drops drops={drops} />
      </div>
    </>
  );
}
